import { render, staticRenderFns } from "./OrderList.vue?vue&type=template&id=5b58c944&scoped=true&"
import script from "./OrderList.vue?vue&type=script&lang=ts&"
export * from "./OrderList.vue?vue&type=script&lang=ts&"
import style0 from "./OrderList.vue?vue&type=style&index=0&id=5b58c944&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b58c944",
  null
  
)

export default component.exports